import styled from "styled-components";

export const HighlightedDate = styled.h5`
  width: 100%;
  text-align: ${(props) => (props?.isHalf ? "center" : "left")};
  color: ${(props) => (props?.isActive ? "#f48120" : "#DDE2E8")};
  font-weight: ${(props) => (props?.isPassed ? "bold" : "normal")};
  line-height: 0;
  font-size: 1.6rem;
  margin-top: 24px;
  margin-bottom: 16px;
`;

export const Stroke = styled.div`
  height: 4px;
  background-color: ${(props) => (props?.isActive ? "#00BCF1" : "#dde2e8")};
  width: ${(props) => props?.width ?? "100%"};
`;

export const Card = styled.div`
  margin-top: 0.8rem;
  min-height: 60px;
  gap: 8px;
  width: max-content;
  min-width: 220px;
  border-radius: 8px;
  border: ${(props) =>
    props?.isActive ? "2px solid #00BCF1" : "2px solid #DDE2E8"};
  background-color: white;
  padding: 8px 12px 0 12px;
  display: flex;
  align-items: center;
  margin-left: ${(props) => props?.marginLeft ?? 0};
  margin-right: ${(props) => props?.marginRight ?? 0};
  cursor: ${(props) => (props?.isActive ? "pointer" : "default")};
  @media only screen and (min-width: 768px) {
    margin-top: 1.6rem;
    min-width: 200px;
  }
`;

export const TitleCard = styled.h6`
  color: ${(props) =>
    props?.isActive
      ? "#00bcf1"
      : props?.isOnGoingActive
      ? "#0397C9"
      : "#6A7481"};
  font-weight: ${(props) =>
    props?.isActive || props?.isOnGoingActive ? "bold" : "normal"};
  font-size: 1.4rem;
  line-height: unset !important;
  @media only screen and (min-width: 768px) {
    font-size: 1.6rem;
    line-height: unset !important;
  }
`;

export const SubtitleCard = styled.h6`
  color: #1f2d3d;

  line-height: 0px;
  font-weight: normal;
  font-size: 1.1rem;
  line-height: unset !important;
  @media only screen and (min-width: 768px) {
    font-size: 1.3rem;
    line-height: unset !important;
  }
`;

export const Icon = styled.img`
  filter: ${(props) => (props?.isActive ? "none" : "grayscale(1)")};
  position: relative;
  top: -4px;
  max-width: 32px;
  max-height: 32px;
`;

export const Container = styled.div`
  flex-direction: row;
  display: flex;
  overflow: auto;
  width: 100%;
  padding-top: 8px;
  padding-bottom: 8px;
  max-width: fit-content;
  margin-left: auto;
  margin-right: auto;
  @media only screen and (min-width: 768px) {
    padding-top: 20px;
    padding-bottom: 0px;
  }
`;

export const TimelineWrapper = styled.div`
  flex-direction: row;
  align-items: center;
  display: flex;
`;
